module.exports = __webpack_public_path__ + "img/ic_faq.f3453ae3.svg";